module.exports = __webpack_public_path__ + "media/images/home/docenti03-089e348da1e4ddbfd6a3c23bfcfb675c.svg";